import { Injectable } from '@angular/core';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { ExitApi } from 'src/app/core/api.gen';
import { CommonService } from 'src/app/core/common.service';
import { ExitDocTypes } from 'src/app/shared/file-upload/doc-types';
import { getInputField, getSelectField, getTextArea, setAsNumeric, setAsRequired } from 'src/app/shared/form';
import { ExitType } from './exittypes/exit-type';

@Injectable({
  providedIn: 'root'
})
export class AdditionalInfoStepService extends ExitType{

  constructor(
    public common: CommonService,
    private exitApi: ExitApi) { 
      super(common, exitApi);
    }

  GetSteps(exitType: string): StepTypeExit[] {
    var steps: StepTypeExit[]=[];
    steps.push(
      {
      label: "IT Team",
      role: 'ITTeam',
      teamInfoprop: 'itTeam',
      showFileUpload: false,
      enableSaveAndSubmit: true,
      docType: ExitDocTypes.IT_TEAM,
      fields: [
        {
          fieldGroupClassName: "row",
          fieldGroup: [
            getTextArea(
              "itAssetDetails",
              "IT asset details",
              setAsRequired())
          ]
        }
      ]
      }
    );
    
    if (exitType == "VoluntaryExit") {
      steps.push(
        {
          label: "Expense team",
          role: 'Expense',
          teamInfoprop: 'expense',
          showFileUpload: true,
          enableSaveAndSubmit: true,
          docType: ExitDocTypes.EXPENSE,
          fields: [
            {
              fieldGroupClassName: "row",
              fieldGroup: [
                getTextArea(
                  "pqDetails",
                  "Expense Details/ School Fee",
                  setAsRequired())
              ]
            }
          ]
        }
      );
    }    

    steps.push(
      {
        label: "LMS team",
        role: 'LMS',
        teamInfoprop: 'lms',
        showFileUpload: false,
        enableSaveAndSubmit: true,
        docType: ExitDocTypes.LMS,
        fields: [
          {
            fieldGroupClassName: "row",
            fieldGroup: [
              getInputField(
                "lmsBalance",
                "LMS balance",
                setAsRequired())
            ]
          }
        ]
      }
    );

    steps.push(
      {
        label: "AMEX team",
        role: 'AMEX',
        teamInfoprop: 'amex',
        showFileUpload: true,
        enableSaveAndSubmit: true,
        docType: ExitDocTypes.AMEX,
        fields: [
          {
            fieldGroupClassName: "row",
            fieldGroup: [
              // getInputField(
              //   "amexCardBalance",
              //   "AMEX card balance"),
              getSelectField(
                "isIndividualHasAmexCard.id",
                "Please confirm if the individual has an AMEX card?",
                this.common.getSelectFieldOptions(this.yesNo$, "",
                  setAsRequired()
                ))
            ]
          },
          {
            fieldGroupClassName: "row",
            fieldGroup: [
              getTextArea(
                "amexComment",
                "Comment",
                setAsRequired())
            ]
          }
        ]
      }
    );

    if (exitType == "VoluntaryExit") {
      steps.push(
        {
          label: "ARC and Canvas / AWS",
          role: 'ARCAndCanvas',
          teamInfoprop: 'arcAndCanvas',
          showFileUpload: false,
          enableSaveAndSubmit: true,
          docType: ExitDocTypes.ARC_AND_CANVAS,
          fields: [
            {
              fieldGroupClassName: "row",
              fieldGroup: [
                getTextArea(
                  "arcAndCanvasComment",
                  "Comment")
              ]
            }
          ]
        }
      );

      steps.push(
        {
          label: "LEADS Team",
          role: 'LEADSTeam',
          teamInfoprop: 'leadsTeam',
          showFileUpload: false,
          enableSaveAndSubmit: true,
          docType: ExitDocTypes.LEADS,
          fields: [
            {
              fieldGroupClassName: "row",
              fieldGroup: [
                getInputField(
                  "leadRating",
                  "Leads rating")
              ]
            }
          ]
        }
      );
    }

    steps.push(
      {
        label: "HRCC Team",
        role: 'HRCC',
        teamInfoprop: 'hrcc',
        showFileUpload: true,
        enableSaveAndSubmit: true,
        docType: ExitDocTypes.HRCC,
        fields: [
          {
            fieldGroupClassName: "row",
            fieldGroup: [
              getTextArea(
                "hrccComment",
                "Comment")
            ]
          }
        ]
      }
    );

    steps.push(
      {
        label: "Finance Team",
        role: 'FinanceTeam',
        teamInfoprop: 'financeTeam',
        showFileUpload: true,
        enableSaveAndSubmit: true,
        docType: ExitDocTypes.FINANCE,
        fields: [
          {
            fieldGroupClassName: "row",
            fieldGroup: [
              getTextArea(
                "financeTeamComment",
                "Comment")
            ]
          }
        ]
      }
    );

    steps.push(
      {
        label: "Immigration Team",
        role: 'VisaApprover',
        teamInfoprop: 'visaApprover',
        showFileUpload: true,
        enableSaveAndSubmit: true,  
        docType: ExitDocTypes.IMMIGRATION,
        fields: [
          {
            fieldGroupClassName: "row",
            fieldGroup: [
              getTextArea(
                "visaApproverComment",
                "Comment")
            ]
          }
        ]
      }
    );

    if (exitType == "VoluntaryExit") {
      steps.push(
        {
          label: "Guidance mail response",
          role: 'GuidanceMail',
          teamInfoprop: 'guidanceMail',
          showFileUpload: false,
          enableSaveAndSubmit: true,
          docType: ExitDocTypes.GUIDANCE_MAIL,
          fields: [
            {
              fieldGroupClassName: "row",
              fieldGroup: [
                getTextArea(
                  "guidanceMailComment",
                  "Comment")
              ]
            }
          ]
        }
      );      
    }

    return steps;
  }
  GetCWSteps():StepTypeExit[]{
    var steps: StepTypeExit[]=[];
    steps.push(
      {
      label: "IT Team",
      role: 'ITTeam',
      teamInfoprop: 'itTeam',
      showFileUpload: false,
      enableSaveAndSubmit: true,
      docType: ExitDocTypes.IT_TEAM,
      fields: [
        {
          fieldGroupClassName: "row",
          fieldGroup: [
            getTextArea(
              "itAssetDetails",
              "IT asset details",
              setAsRequired())
          ]
        }
      ]
      }
    );
    return steps;
  }

}

export interface StepTypeExit {
  label: string;
  role: string;
  showFileUpload: boolean;
  fields: FormlyFieldConfig[];
  enableSaveAndSubmit:boolean;
  docType:ExitDocTypes;
  teamInfoprop:string
}
